import { createContext } from 'react'

type SnackbarContextProps = {
  open: boolean
  message: string
  color: string
  setOpen: any
  setMessage: any
  setColor: any
}

const defaultSnackbarContextProps = {
  open: null,
  message: null,
  color: null,
  setOpen: () => {
    return
  },
  setMessage: () => {
    return
  },
  setColor: () => {
    return
  }
}

export const SnackbarContext = createContext<SnackbarContextProps>(defaultSnackbarContextProps)
